import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Checkbox } from "./ui/checkbox";
import { Badge } from "./ui/badge";
import { UserPlus, X } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "../lib/format";
import { divisionById } from "../lib/constants";

export default function CoordinatorAssign({ bookingId, canEdit }) {
  const [assigned, setAssigned] = useState([]);
  const [eligible, setEligible] = useState([]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([]);

  const load = async () => {
    const [{ data: ass }, { data: elig }] = await Promise.all([
      api.get(`/bookings/${bookingId}/coordinators`),
      canEdit ? api.get("/coordinators/eligible") : Promise.resolve({ data: [] }),
    ]);
    setAssigned(ass);
    setEligible(elig);
    setSelected(ass.map((u) => u.id));
  };
  useEffect(() => { load(); }, [bookingId]);

  const save = async () => {
    try {
      await api.put(`/bookings/${bookingId}/coordinators`, { user_ids: selected });
      toast.success("Coordinator diperbarui"); setOpen(false); load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="coordinator-widget">
      <div className="flex items-center gap-2 mb-2">
        <div className="text-xs font-semibold uppercase text-[#8C9096]">Package Coordinator</div>
        {canEdit && <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid="btn-assign-coordinator"><UserPlus className="w-3.5 h-3.5 mr-1"/> Kelola</Button>}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {assigned.length === 0 && <span className="text-xs text-[#8C9096] italic">Belum ada coordinator ditugaskan</span>}
        {assigned.map((u) => (
          <Badge key={u.id} variant="outline" className="text-[11px]">
            {u.name} <span className="text-[#8C9096] ml-1">({divisionById(u.division_id)?.short})</span>
          </Badge>
        ))}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="modal-assign-coordinator">
          <DialogHeader><DialogTitle>Kelola Package Coordinator</DialogTitle></DialogHeader>
          <div className="text-xs text-[#5C6066] mb-3">Coordinator hanya bisa dipilih dari Admin/Manager MUA & WO. Mereka akan dapat akses cross-division khusus untuk booking ini.</div>
          <div className="space-y-2">
            {eligible.length === 0 && <div className="text-sm text-[#8C9096] italic">Tidak ada kandidat eligible.</div>}
            {eligible.map((u) => (
              <label key={u.id} className="flex items-center gap-3 p-2 rounded hover:bg-[#FAF6EE] cursor-pointer" data-testid={`coord-option-${u.id}`}>
                <Checkbox checked={selected.includes(u.id)} onCheckedChange={(c) => setSelected(c ? [...selected, u.id] : selected.filter((x) => x !== u.id))} />
                <div className="flex-1">
                  <div className="text-sm font-medium">{u.name}</div>
                  <div className="text-[11px] text-[#8C9096]">{u.email} · {divisionById(u.division_id)?.short} · {u.role}</div>
                </div>
              </label>
            ))}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Batal</Button>
            <Button className="bg-brand text-white" onClick={save} data-testid="btn-save-coordinator">Simpan</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
